import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resultsCount'
})
export class ResultsCountPipe implements PipeTransform {

  transform(value: any): string {
      return value === -1 ? '-' : value;
  }

}
